
import { defineComponent } from 'vue';
import { useField } from 'vee-validate';
import AppFormItem from '@/components/UI/AppFormItem.vue';

export default defineComponent({
  inheritAttrs: false,
  components: { AppFormItem },
  props: {
    name: { type: String, required: true },
    error: { type: String, default: '' },
    label: { type: String, default: '' },
    controlClass: { type: String, default: '' },
    position: { type: String, default: 'center' },
    previousValue: { },
  },
  setup(props) {
    const { value, errorMessage } = useField(props.name);

    const currentValue = value.value || props.previousValue;

    return { value: currentValue, errorMessage };
  },
});
